import type { Routes } from '@angular/router';

export const AGGREGATED_STATISTICS_PDF_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-statistics-pdf-layout/aggregated-statistics-pdf-layout.component').then(
                (m) => m.AggregatedStatisticsPdfLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'seo',
            },
            {
                path: 'seo',
                loadChildren: () =>
                    import('#modules/statistics-seo/routes/aggregated-statistics-seo.routes').then(
                        (m) => m.AGGREGATED_SEO_STATISTICS_PDF_ROUTES
                    ),
            },
            {
                path: 'e-reputation',
                loadChildren: () =>
                    import('#modules/statistics-e-reputation/routes/aggregated-e-reputation-statistics.routes').then(
                        (m) => m.AGGREGATED_E_REPUTATION_STATISTICS_PDF_ROUTES
                    ),
            },
            {
                path: 'social-networks',
                loadChildren: () =>
                    import('#modules/statistics-social-networks/routes/aggregated-social-networks.routes').then(
                        (m) => m.AGGREGATED_SOCIAL_NETWORKS_STATISTICS_PDF_ROUTES
                    ),
            },
            {
                path: 'boosters',
                loadChildren: () =>
                    import('#modules/statistics-boosters/routes/aggregated-boosters-statistics.routes').then(
                        (m) => m.AGGREGATED_BOOSTERS_STATISTICS_PDF_ROUTES
                    ),
            },
        ],
    },
];
